import { ZodType, z } from 'zod/v4'

export const nullableInput = <T extends ZodType>(schema: T, message?: string, fatal = true) => {
    return schema.nullable().transform((value, ctx) => {
        if (value === null) {
            ctx.addIssue({ code: 'custom', fatal, message })

            return z.NEVER
        }

        return value
    })
}
